<div class="progress-bar" [class.disabled]="!canPlay" (click)="seek($event)">
  <div #progress class="current-progress"></div>
</div>
